import EllipsisIcon from './EllipsisIcon'

export default EllipsisIcon
